var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80098 9.19962H9.60056C10.9254 9.19962 12.0003 8.12472 12.0003 6.79983H12.8003C14.5651 6.79983 16 5.36496 16 3.60011C16 1.83527 14.5651 0.400391 12.8003 0.400391H3.00114C2.66866 0.400391 2.40119 0.667867 2.40119 1.00034V6.79983C2.40119 8.12472 3.47609 9.19962 4.80098 9.19962ZM12.8003 2.00025C13.6827 2.00025 14.4001 2.71769 14.4001 3.60011C14.4001 4.48253 13.6827 5.19997 12.8003 5.19997H12.0003V2.00025H12.8003ZM13.9927 11.5994H1.20879C0.0188963 11.5994 -0.316074 9.99955 0.308871 9.99955H14.8901C15.515 9.99955 15.1851 11.5994 13.9927 11.5994Z",
    fill: "#004E98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.05f6b0e559ff80041517cdedc945cffc.svg";
export { ForwardRef as ReactComponent };